export const API_ENDPOINTS = {
  ATTENDANCE: {
    // get calender
    GET_CALENDAR: (empIds, dateObj) =>
      `/employee-attendance?empId=${empIds}&currentMonth=${dateObj}`,

    // approvals
    GET_APPROVAL: (key) =>
      `/attendance-regularization/all-regularization?key=${key}`,

    FETCH_ONSITE: ({ referenceName }) =>
      `/employee-attendance/web-location?referenceName=${referenceName}`,

    SWIPE_WORK_DETAILS: (empId, dateObj) =>
      `/employee-attendance/today-shift?date=${dateObj}`,

    // GET_ONSITE_APPROVAL
    GET_ONSITE_APPROVAL: (key) =>
      `/employee-attendance/web-attendance?status=${key}`,
    PUT_ONSITE_APPROVAL: (status, empId, date, month, reason) => {
      const queryParams = new URLSearchParams();

      if (status) queryParams.append("status", status);
      if (empId) queryParams.append("empId", empId);
      if (date) queryParams.append("date", date);
      if (month) queryParams.append("month", month);

      // Only include reason if status is Rejected
      if (status === "Rejected" && reason) {
        queryParams.append("reason", reason);
      }

      return `/employee-attendance/web-attendance-approval?${queryParams.toString()}`;
    },

    // regularization
    GET_EMPLOYEE_REGULARIZATION: (key) =>
      `/attendance-regularization/emp-regularization?key=${key}`,

    // approve regularization
    GET_APPROVE_REGULARIZATION: (
      empId,
      regCode,
      key,
      approvedDate,
      rejectedDate,
      remarks,
    ) =>
      `/attendance-regularization/regularization-approved?empId=${empId}&regCode=${regCode}&key=${key}&approvedDate=${approvedDate}&rejectedDate=${rejectedDate}&remarks=${remarks}`,

    // withdraw
    GET_WITHDRAW_REGULARIZATION: (empId, regCode, yearMonth) =>
      `/attendance-regularization/withdrawal?empId=${empId}&regCode=${regCode}&monthYear=${yearMonth}`,

    GET_WITHDRAW_REGULARIZATION_BY_DATE: (empId, regCode) =>
      `/attendance-regularization/withdrawal-by-date?empId=${empId}&regCode=${regCode}`,

    // quick Add
    GET_QUICK_ADD: (yearMonth) =>
      `/attendance-regularization/regularization-quick-add?monthYear=${yearMonth}`,

    // applied to
    GET_APPLIED_TO: () => `/attendance-regularization/get-applied-to`,

    // absent-present
    GET_ABSENT_PRESENT: (yearMonth) =>
      `/attendance-regularization/absent-present?currentMonth=${yearMonth}`,

    // apply-regularization
    POST_APPLY_REGULARIZATION: () => `/attendance-regularization`,

    SWIPE_DETAILS: (empID) => `/employee-attendance/attendance-swipe`,
    SWIPE_DETAILS_DATE: (empID, Date) =>
      `/employee-attendance/attendance-date-wise?empId=${empID}&date=${Date}`,

    // absent-present-list
    GET_ABSENT_PRESENT_LIST: (yearMonth) =>
      `/attendance-regularization/present-absent-list?currentMonth=${yearMonth}`,

    // employee attendnace muster
    // GET_EMPLOYEE_ATTENDANCE_MUSTER: (empId,yearMonth) =>`/attendance-muster/employee?empId=${empId}&monthYear=${yearMonth}`,
    GET_EMPLOYEE_ATTENDANCE_MUSTER: (
      empId,
      yearMonth,
      sortDirection,
      page,
      size,
      search,
    ) => {
      const queryParams = new URLSearchParams();

      if (empId) queryParams.append("empId", empId); // Only add empId if it's defined
      if (yearMonth) queryParams.append("monthYear", yearMonth); // Always include yearMonth
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);

      return `/attendance-muster/employee?${queryParams.toString()}`;
    },

    GET_EMPLOYEE_ATTENDANCE_MUSTER_LIST: () =>
      `/attendance-muster/employee-list`,
    GET_PAYROLL_LOCK_DATE: (yearMonth) =>
      `/attendance-regularization/payroll-lock-date?currentMonth=${yearMonth}`,
    GET_PAYROLL_LOCK_DATE_INFO: (yearMonth) =>
      `/attendance-regularization/payroll-lock-date?currentMonth=${yearMonth}`,
    // POST_EMPLOYEE_SIGNING: (location, isSign) => `/employee-attendance/web-login?location=${location}&isSign=${isSign}`,
    POST_EMPLOYEE_SIGNING: (location, isSign) =>
      `/employee-attendance/login?location=${location}&isSign=${isSign}`,
    GET_EMPLOYEE_SIGN: `/employee-attendance/today-attendance`,

    GET_MUSTER_DYNAMIC_HEADERS: () =>
      `/attendance-muster/muster-dynamic-headers`,
  },
  ATTENDANCE_REPORT: {
    GET_EMPLOYEE_ATTENDANCE_REPORT: (
      month,
      sortDirection,
      page,
      size,
      search,
    ) => {
      const queryParams = new URLSearchParams();
      if (month) queryParams.append("month", month);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (search) queryParams.append("search", search);
      return `/employee-attendance/repo-manager-report?${queryParams.toString()}`;
    },
  },
  ATTENDANCE_EMPLOYEE_TRACKER: {
    GET_MY_TEAM_REPORT: (startDate, endDate, schema) => {
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (schema) queryParams.append("schema", schema);
      return `employee-attendance/attendance-employee-tracker-new?${queryParams.toString()}`;
    },
    GET_TEAM_MEMBER_REPORT: (startDate, endDate, empId) => {
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (empId) queryParams.append("empId", empId);
      return `employee-attendance/attendance-team-member-report?${queryParams.toString()}`;
    },
  },
};
